import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { ArrowRight } from 'lucide-react';
import { ReserveButton } from './ReserveButton';
// 3130 Crow Canyon Place, San Ramon, CA 94583
const LOCATION: [number, number] = [37.77264, -121.95688];
const DIRECTIONS_URL = 'https://maps.app.goo.gl/zFPT8SmTFASH1E3L6';
export function DetailsSection() {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstance = useRef<L.Map | null>(null);
  useEffect(() => {
    if (!mapRef.current || mapInstance.current) return;
    const map = L.map(mapRef.current, {
      center: LOCATION,
      zoom: 15,
      zoomControl: false,
      scrollWheelZoom: false,
      attributionControl: false
    });
    mapInstance.current = map;
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
      maxZoom: 19,
      subdomains: 'abcd',
      className: 'bc-map-tiles'
    }).addTo(map);
    const pinIcon = L.divIcon({
      className: '',
      html: '<div style="width:18px;height:18px;border-radius:9999px;background:#FF1F8F;box-shadow:0 0 0 1px rgba(255,31,143,0.45),0 0 24px 4px rgba(255,31,143,0.55);"></div>',
      iconSize: [18, 18],
      iconAnchor: [9, 9]
    });
    L.marker(LOCATION, {
      icon: pinIcon
    }).addTo(map).on('click', () => window.open(DIRECTIONS_URL, '_blank', 'noopener,noreferrer'));
    // Ensure tiles lay out correctly once the container has its final size
    const t = setTimeout(() => map.invalidateSize(), 200);
    return () => {
      clearTimeout(t);
      map.remove();
      mapInstance.current = null;
    };
  }, []);
  return <section id="details" className="relative py-24 md:py-32 bg-bc-bg" data-id="element-25">
      <div className="container mx-auto px-6" data-id="element-26">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16" data-id="element-27">
          {/* Left: Details */}
          <div className="space-y-8" data-id="element-28">
            <div className="space-y-4" data-id="element-29">
              <div className="flex flex-col gap-1" data-id="element-30">
                <span className="text-bc-bone-3 font-sans text-sm tracking-label uppercase" data-id="element-31">
                  DATE
                </span>
                <span className="text-bc-bone font-sans text-lg md:text-xl" data-id="element-32">
                  Wednesday, June 24th
                </span>
              </div>
              <div className="flex flex-col gap-1" data-id="element-33">
                <span className="text-bc-bone-3 font-sans text-sm tracking-label uppercase" data-id="element-34">
                  TIME
                </span>
                <span className="text-bc-bone font-sans text-lg md:text-xl" data-id="element-35">
                  6:00 to 8:00 pm
                </span>
              </div>
              <div className="flex flex-col gap-1" data-id="element-36">
                <span className="text-bc-bone-3 font-sans text-sm tracking-label uppercase" data-id="element-37">
                  LOCATION
                </span>
                <span className="text-bc-bone font-sans text-lg md:text-xl" data-id="element-38">
                  Be CLINICAL
                  <br data-id="element-39" />
                  3130 Crow Canyon Place
                  <br data-id="element-40" />
                  San Ramon, CA 94583
                </span>
              </div>
            </div>

            <ReserveButton label="RESERVE YOUR SPOT" className="w-full sm:w-auto" data-id="element-41" />
          </div>

          {/* Right: Real dark map */}
          <div className="relative h-[300px] md:h-[400px] bg-bc-surface rounded-bc overflow-hidden border border-hairline" data-id="element-42">
            <div ref={mapRef} className="absolute inset-0 z-0" aria-label="Map showing Be CLINICAL in San Ramon, CA" data-id="element-43" />

            {/* Get directions */}
            <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" className="absolute bottom-4 left-4 right-4 z-20 flex items-center justify-center gap-2 h-11 rounded-full bg-bc-bg/80 backdrop-blur-sm border border-bc-pink text-bc-bone font-sans text-xs tracking-label uppercase bc-glow-box-soft hover:bc-glow-box transition-all bc-ease" data-id="element-44">
              GET DIRECTIONS
              <ArrowRight className="w-4 h-4" strokeWidth={1.5} data-id="element-45" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}